import { format, Locale } from "date-fns";
import { enUS } from "date-fns/locale";
import { inject } from "vue";


export default () => {
  // Access the global locale from app.config.globalProperties
  const globalLocale: Locale = inject("$dateLocale", enUS);

  // Convert a date to UTC-equivalent local date for formatting.
  // date-fns format() always uses local timezone, but our app stores all times in UTC.
  const toUTCDate = (date: Date): Date => {
    return new Date(date.getTime() + date.getTimezoneOffset() * 60000);
  };

  const formatDate = (
    isoDate?: string | Date,
    longFormat: boolean = false,
    longWeekday: boolean = true,
  ): string => {
    if (!isoDate) return "";
    const date = toUTCDate(new Date(isoDate));
    // Use short weekday such as "Mon", "Tue"...
    // Or long weekday such as "Monday", "Tuesday"...
    const weekdayFormat = longWeekday ? "EEEE" : "EEE";

    const strFormat = longFormat
      ? `${weekdayFormat}, d. LLL yyyy`
      : "d. LLL yyyy";
    return format(date, strFormat, { locale: globalLocale });
  };

  const formatDatetime = (isoDate?: string): string => {
    if (!isoDate) return "";
    const date = toUTCDate(new Date(isoDate));
    return format(date, "d. LLL yyyy", { locale: globalLocale }) + " " + formatTime(isoDate);
  };

  const formatTime = (isoDate?: string): string => {
    if (!isoDate) return "";
    const date = toUTCDate(new Date(isoDate));
    return format(date, "HH:mm");
  };

  // Short weekday and time, such as "Thu, 12:30".
  const formatWeekdayTime = (isoDate?: string | Date): string => {
    if (!isoDate) return "";
    const date = toUTCDate(new Date(isoDate));
    return format(date, "EEE, HH:mm", { locale: globalLocale });
  };

  return { formatDate, formatDatetime, formatTime, formatWeekdayTime };
};
